import { Box, Fab } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { whatsappUrl } from '../store/contactInfo';

export default function WhatsAppFloat() {
  const href = whatsappUrl("Hello, I'm interested in Modurax storage solutions.");
  return (
    <Box sx={{ position: 'fixed', right: { xs: 12, sm: 16 }, bottom: { xs: 12, sm: 16 }, zIndex: 1500, pb: 'env(safe-area-inset-bottom)', pr: 'env(safe-area-inset-right)' }}>
      <Fab color="primary" aria-label="whatsapp" href={href} target="_blank" rel="noopener noreferrer" sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#1ebe5d' } }}>
        <WhatsAppIcon sx={{ color: '#fff' }} />
      </Fab>
    </Box>
  );
}
